import type * as Types from "../../schema.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CreateDeclarationDocumentAssetMutationVariables = Types.Exact<{
  declarationDocumentId: Types.Scalars["ID"];
  name: Types.Scalars["String"];
  filetype: Types.Scalars["String"];
}>;

export type CreateDeclarationDocumentAssetMutation = {
  __typename?: "Mutation";
  createDeclarationDocumentAsset: {
    __typename?: "CreateAssetResponse";
    assetId: string;
    url: string;
    formData: Array<{
      __typename?: "FormDataPair";
      key: string;
      value: string;
    }>;
  };
};

export const CreateDeclarationDocumentAssetDocument = gql`
  mutation createDeclarationDocumentAsset(
    $declarationDocumentId: ID!
    $name: String!
    $filetype: String!
  ) {
    createDeclarationDocumentAsset(
      declarationDocumentId: $declarationDocumentId
      name: $name
      filetype: $filetype
    ) {
      assetId
      url
      formData {
        key
        value
      }
    }
  }
`;
export type CreateDeclarationDocumentAssetMutationFn = Apollo.MutationFunction<
  CreateDeclarationDocumentAssetMutation,
  CreateDeclarationDocumentAssetMutationVariables
>;

/**
 * __useCreateDeclarationDocumentAssetMutation__
 *
 * To run a mutation, you first call `useCreateDeclarationDocumentAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeclarationDocumentAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeclarationDocumentAssetMutation, { data, loading, error }] = useCreateDeclarationDocumentAssetMutation({
 *   variables: {
 *      declarationDocumentId: // value for 'declarationDocumentId'
 *      name: // value for 'name'
 *      filetype: // value for 'filetype'
 *   },
 * });
 */
export function useCreateDeclarationDocumentAssetMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateDeclarationDocumentAssetMutation,
    CreateDeclarationDocumentAssetMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateDeclarationDocumentAssetMutation,
    CreateDeclarationDocumentAssetMutationVariables
  >(CreateDeclarationDocumentAssetDocument, options);
}
export type CreateDeclarationDocumentAssetMutationHookResult = ReturnType<
  typeof useCreateDeclarationDocumentAssetMutation
>;
export type CreateDeclarationDocumentAssetMutationResult =
  Apollo.MutationResult<CreateDeclarationDocumentAssetMutation>;
export type CreateDeclarationDocumentAssetMutationOptions =
  Apollo.BaseMutationOptions<
    CreateDeclarationDocumentAssetMutation,
    CreateDeclarationDocumentAssetMutationVariables
  >;
